import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(
  <>
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(-1080 -347)">
      <g transform="translate(29 3)">
        <path
          d="M-816.191,5274.229l-16.112-.135V5258.1h4.909v2H-830.3v12.006l12.112.1v-2.872h2Z"
          transform="translate(1888 -4909)"
        />
        <path
          d="M.707,10.515-.707,9.1,9.1-.707,10.515.707Z"
          transform="translate(1062.889 348.169)"
        />
        <path
          d="M-817.553,5267.288h-2v-7.231h-7.287v-2h9.287Z"
          transform="translate(1891.25 -4910.887)"
        />
      </g>
    </g>
  </>,
  '0 0 26 26'
);
